// extracted by mini-css-extract-plugin
module.exports = {"main":"Lottery_main__RAUxy","bigCard":"Lottery_bigCard__9gzv1","countdownLabel":"Lottery_countdownLabel__7sbL1","dopCard":"Lottery_dopCard__3XPvS"};